export const headerInitialStore = {
  waffle: {
    mobileLabel: '',
    menuItems: []
  }
};
